import { AvailableLocales } from "types";

const helpCenterLocaleMap: Partial<Record<AvailableLocales, string>> = {
  [AvailableLocales.German]: "de-de",
  [AvailableLocales.French]: "fr-fr",
  [AvailableLocales.Spanish]: "es",
  [AvailableLocales.Italian]: "it",
  [AvailableLocales.Dutch]: "nl",
};

/**
 * Returns the localized help center base URL for the given locale.
 * Optionally appends an article path.
 *
 * @param locale - The locale identifier (e.g. "en-GB", "de-DE", "fr") —
 *                 only the first two characters are used.
 * @param articlePath - Optional article path to append (e.g. "/articles/12345-My-Article").
 *                      Should start with "/".
 */
export function getHelpCenterUrl(locale: string, articlePath: string = ""): string {
  const language = locale.slice(0, 2) as AvailableLocales;
  const helpCenterLanguage = helpCenterLocaleMap[language] ?? "en-us";

  return `https://help.deskbird.com/hc/${helpCenterLanguage}${articlePath}`;
}
